import { BaseKeyboardEvent, KeyboardEventKeyCode, handleKeyCodeTriggers } from "@civicscience/chops";

const handleEnterSpaceKey = (event: BaseKeyboardEvent, callback: () => void) => {
  return handleKeyCodeTriggers(event, [KeyboardEventKeyCode.Enter, KeyboardEventKeyCode.Space], callback);
};

export default handleEnterSpaceKey;
